<template>
  <div id="event">
    <transition name="fade">
      <div v-if="showInvitationAttendanceInConfirmation" class="alertBox">
        <div>
          <h5>Change Attendance</h5>
          <p>Glad you're able to attend. Change your attendance to IN?</p>
          <button class="destructive" v-on:click="showInvitationAttendanceInConfirmation = false;">No</button>
          <button v-on:click="showInvitationAttendanceInConfirmation = false; updateInvitationAttendanceStatus(selectedEvent, appUser, 1)">Yes</button>
        </div>
      </div>
      <div v-if="showInvitationAttendanceInPlusOneConfirmation" class="alertBox">
        <div>
          <h5>Change Attendance</h5>
          <p>Glad you're able to attend...with a friend! Change your attendance to IN plus one?</p>
          <button class="destructive" v-on:click="showInvitationAttendanceInPlusOneConfirmation = false;">No</button>
          <button v-on:click="showInvitationAttendanceInPlusOneConfirmation = false; updateInvitationAttendanceStatus(selectedEvent, appUser, 2)">Yes</button>
        </div>
      </div>
      <div v-if="showInvitationAttendanceOutConfirmation" class="alertBox">
        <div>
          <h5>Change Attendance</h5>
          <p>Too bad you can't make it. Change your attendance to OUT?</p>
          <button class="destructive" v-on:click="showInvitationAttendanceOutConfirmation = false;">No</button>
          <button v-on:click="showInvitationAttendanceOutConfirmation = false; updateInvitationAttendanceStatus(selectedEvent, appUser, 3)">Yes</button>
        </div>
      </div>
    </transition>

    <div v-if="eventCalloutText(selectedEvent, false)" :class="eventCalloutContainerStyle(selectedEvent)">
      <div class="callout">
        <span v-if="eventCalloutText(selectedEvent, true)" class="calloutFragment">{{ eventCalloutText(selectedEvent, false).toUpperCase() }}</span>
      </div>
    </div>

    <div id="eventContent" v-if="selectedEvent">
      <div class="mediaItemList" v-if="selectedEvent.mediaItems && selectedEvent.mediaItems.length > 0">
        <vue-horizontal ref="horizontal" class="horizontal" :button-between="false" @scroll-debounce="onScrollDebounce">
          <div v-for="(mediaItem, index) in selectedEvent.mediaItems" v-bind:key="index" class="mediaContainer">
            <div v-if="mediaItem.type == $MediaItemType.video">
              <video class="media" preload="auto" controls autoplay playsinline muted>
                <source :src="mediaItem.link" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div v-else>
              <img :src="mediaItem.link" class="media" />
            </div>
            <div class="mediaCredit"><span v-if="mediaItem.creator.givenName">{{ mediaItem.creator.givenName }}</span> <span v-if="mediaItem.creator.givenName">{{ mediaItem.creator.familyName }}</span></div>
            <!-- <a :href="mediaItem.link" download><div class="actionButton"><span class="material-symbols-outlined">download</span></div></a> -->
          </div>
        </vue-horizontal>
      </div>

      <div v-if="selectedEvent.mediaItems && selectedEvent.mediaItems.length > 1" class="pageControl">
        <div class="dot" :class="{current: i - 1 === index}" v-for="i in pages" :key="i" @click="onPageTapped(i - 1, selectedEvent.mediaItems)">
          <div></div>
        </div>
      </div>

      <section>
        <div class="row name">{{ selectedEvent.name }}</div>

        <div class="row">
          <div style="position: relative">
            <img src="../assets/images/EventDetail_WhenIcon.png" width="35" height="30" class="colorizePrimary"/>
            <div v-if="isChangeStatusSetForUserInvitation(invitationForAppUser(selectedEvent, appUser), $InvitationChangeStatus.eventDateChanged) || isChangeStatusSetForUserInvitation(invitationForAppUser(selectedEvent, appUser), $InvitationChangeStatus.eventTimeChanged)">
              <div class="statusDotBackground" style="position: absolute; top: -8px; right: -8px"></div>
              <div class="statusDot" style="position: absolute; top: -5px; right: -5px"></div>
            </div>
          </div>
          <p class="heading">{{ formattedDateTimeString(selectedEvent.dateTime.toDate(), selectedEvent.location, appUser.timeZoneIdentifier) }}</p>
        </div>

        <div class="row" v-if="selectedEvent.location">
          <div style="position: relative">
            <img src="../assets/images/EventDetail_WhereIcon.png" class="colorizePrimary" width="35" height="30" />
            <div v-if="isChangeStatusSetForUserInvitation(invitationForAppUser(selectedEvent, appUser), $InvitationChangeStatus.eventLocationChanged)">
              <div class="statusDotBackground" style="position: absolute; top: -8px; right: -8px"></div>
              <div class="statusDot" style="position: absolute; top: -5px; right: -5px"></div>
            </div>
          </div>
          <p class="heading">{{ selectedEvent.location.name }} ({{ selectedEvent.location.cityState }}) <span class="material-symbols-outlined" v-if="selectedEvent.weatherForecast">{{ googleWeatherSymbolForSfSymbol(selectedEvent.weatherForecast.forecastSymbolName) }}</span> <span v-if="selectedEvent.weatherForecast">{{ selectedEvent.weatherForecast.forecastTemperatureFormatted }} {{ selectedEvent.weatherForecast.forecastPrecipitationChanceFormatted }}</span> <span class="material-symbols-outlined-small">humidity_high</span></p>
        </div>

        <div class="row" v-if="selectedEvent.messages && selectedEvent.messages.length > 0">
          <div style="position: relative">
          <img src="../assets/images/EventDetail_MessageIcon.png" class="colorizePrimary" width="35" height="30" />
            <div v-if="isChangeStatusSetForUserInvitation(invitationForAppUser(selectedEvent, appUser), $InvitationChangeStatus.eventMessagesAdded)">
              <div class="statusDotBackground" style="position: absolute; top: -8px; right: -8px"></div>
              <div class="statusDot" style="position: absolute; top: -5px; right: -5px"></div>
            </div>
          </div>
          <div class="col1">
            <p class="heading">Messages ({{ selectedEvent.messages && selectedEvent.messages.length }})</p>
          </div>
        </div>
        <div class="messageList" v-if="selectedEvent.messages && selectedEvent.messages.length > 0" @click="showMessages(selectedEvent)">
          <div v-if="selectedEvent.messages && selectedEvent.messages.length > 0">
            <div class="messageEllipsis" v-if="selectedEvent.messages && selectedEvent.messages.length > 1">
              <span class="material-symbols-outlined">more_horiz</span>
            </div>
            <div class="message">
              <div class="messageHeading">{{ mostRecentMessage(selectedEvent.messages).sender.givenName }} {{ mostRecentMessage(selectedEvent.messages).sender.familyName }}, {{ formattedDateTimeString(mostRecentMessage(selectedEvent.messages).dateTime.toDate(), selectedEvent.location, appUser.timeZoneIdentifier) }}</div>
              <div :class="appUser && (appUser.uid == mostRecentMessage(selectedEvent.messages).sender.userId) ? 'messageBody_sender' : 'messageBody_notSender'">{{ mostRecentMessage(selectedEvent.messages).body }}</div>
            </div>
          </div>
          <!-- <div v-if="selectedEvent.messages && selectedEvent.messages.length > 0">
            <div v-for="(message, i) in selectedEvent.messages" v-bind:key="i" class="message">
              <div class="messageHeading">{{ message.sender.givenName }} {{ message.sender.familyName }}, {{ formattedDateTimeString(message.dateTime.toDate(), selectedEvent.location, appUser.timeZoneIdentifier) }}</div>
              <div :class="appUser && (appUser.uid == message.sender.userId) ? 'messageBody_sender' : 'messageBody_notSender'">{{ message.body }}</div>
            </div>
          </div> -->
        </div>

        <div class="row">
          <div style="position: relative">
            <img src="../assets/images/EventDetail_WhoIcon.png" class="colorizePrimary" width="35" height="30" />
            <div v-if="isChangeStatusSetForUserInvitation(invitationForAppUser(selectedEvent, appUser), $InvitationChangeStatus.inviteesAdded) || isChangeStatusSetForUserInvitation(invitationForAppUser(selectedEvent, appUser), $InvitationChangeStatus.inviteesRemoved) || isChangeStatusSetForUserInvitation(invitationForAppUser(selectedEvent, appUser), $InvitationChangeStatus.inviteesAttendanceChanged)">
              <div class="statusDotBackground" style="position: absolute; top: -8px; right: -8px"></div>
              <div class="statusDot" style="position: absolute; top: -5px; right: -5px"></div>
            </div>
          </div>
          <div class="col1">
            <p class="heading">Invitees ({{ selectedEvent.invitations.length }})</p>
          </div>
          <div class="col2" style="text-align: right">
            <span class="attendanceCountIn"><img src="../assets/images/AttendanceStatusIcon_In.png" class="colorizeAttendanceStatusAttending" width="16" height="16"> {{ eventInvitationAttendanceCount(selectedEvent, 1) + eventInvitationAttendanceCount(selectedEvent, 2) * 2 }}</span>
            <span class="attendanceCountOut"><img src="../assets/images/AttendanceStatusIcon_Out.png" class="colorizeAttendanceStatusNotAttending" width="16" height="16"> {{ eventInvitationAttendanceCount(selectedEvent, 3) }}</span>&nbsp;
            <span class="attendanceCountUndecided"><img src="../assets/images/AttendanceStatusIcon_Undecided.png" class="colorizeAttendanceStatusUndecided" width="16" height="16"> {{ eventInvitationAttendanceCount(selectedEvent, 0) + eventInvitationAttendanceCount(selectedEvent, 4) }}</span>
          </div>
        </div>
        <div class="inviteeList">
          <div v-if="selectedEvent.invitations.length">
            <div v-for="invitation in selectedEvent.invitations" v-bind:key="invitation.id" class="invitation">
              <div class="col1">
                <div v-if="invitation.invitee">
                  <p>{{ invitation.invitee.givenName }} {{ invitation.invitee.familyName }}</p>
                </div>
                <div v-else>
                  <p>Unknown</p>
                </div>
              </div>
              <div class="col2">
                <img v-if="invitation.attendanceStatus == 0" src="../assets/images/AttendanceStatusIcon_Unknown.png" class="colorizeAttendanceStatusUnknown" width="16" height="16" />
                <img v-if="invitation.attendanceStatus == 1" src="../assets/images/AttendanceStatusIcon_In.png" class="colorizeAttendanceStatusAttending" width="16" height="16" />
                <img v-if="invitation.attendanceStatus == 2" src="../assets/images/AttendanceStatusIcon_InPlusOne.png" class="colorizeAttendanceStatusAttending" width="16" height="16" />
                <img v-if="invitation.attendanceStatus == 3" src="../assets/images/AttendanceStatusIcon_Out.png" class="colorizeAttendanceStatusNotAttending" width="16" height="16" />
                <img v-if="invitation.attendanceStatus == 4" src="../assets/images/AttendanceStatusIcon_Undecided.png" class="colorizeAttendanceStatusUndecided" width="16" height="16" />
              </div>
            </div>
          </div>
          <div v-else>
            <p class="emptyList">No invitees</p>
          </div>
        </div>

        <div v-if="!isEventCanceled(selectedEvent) && isEventUpcomingOrNow(selectedEvent)" style="display: flex">
          <template v-if="invitationForAppUser(selectedEvent, appUser).attendanceStatus == 3">
            <button class="attendanceButtonOut_selected">
              <img class="colorizeAttendanceStatusNotAttending" src="../assets/images/AttendanceStatusIcon_Out.png" width="32" height="32" /> <span>YOU ARE OUT</span>
            </button>
          </template>
          <template v-else>
            <button :class="canSetEventNotAttending(selectedEvent, appUser) ? 'attendanceButtonOut' : 'attendanceButtonOut_disabled'" v-on:click="canSetEventNotAttending(selectedEvent, appUser) && attendanceOutButtonTapped(selectedEvent, appUser)">
              <img class="colorizeBackground" src="../assets/images/AttendanceStatusIcon_Out.png" width="32" height="32" />
            </button>
          </template>
          <template v-if="selectedEvent.settings && selectedEvent.settings.allowPlusOnes">
            <template v-if="invitationForAppUser(selectedEvent, appUser).attendanceStatus == 2">
              <button class="attendanceButtonIn_selected">
                <img class="colorizeBackground" src="../assets/images/AttendanceStatusIcon_InPlusOne.png" width="32" height="32" /> <span>YOU ARE IN+1</span>
              </button>
            </template>
            <template v-else>
              <button :class="canSetEventAttendingPlusOne(selectedEvent, appUser) ? 'attendanceButtonIn' : 'attendanceButtonIn_disabled'" v-on:click="canSetEventAttendingPlusOne(selectedEvent, appUser) && attendanceInPlusOneButtonTapped(selectedEvent, appUser)">
                <img class="colorizeBackground" src="../assets/images/AttendanceStatusIcon_InPlusOne.png" width="32" height="32" />
              </button>
            </template>
          </template>
          <template v-if="invitationForAppUser(selectedEvent, appUser).attendanceStatus == 1">
            <button class="attendanceButtonIn_selected">
              <img class="colorizeAttendanceStatusAttending" src="../assets/images/AttendanceStatusIcon_In.png" width="32" height="32" /> <span>YOU ARE IN</span>
            </button>
          </template>
          <template v-else>
            <button :class="canSetEventAttending(selectedEvent, appUser) ? 'attendanceButtonIn' : 'attendanceButtonIn_disabled'" v-on:click="canSetEventAttending(selectedEvent, appUser) && attendanceInButtonTapped(selectedEvent, appUser)">
              <img class="colorizeBackground" src="../assets/images/AttendanceStatusIcon_In.png" width="32" height="32" />
            </button>
          </template>
        </div>
      </section>
    </div>
    <div v-else>
      <p class="emptyList">There isn't an event</p>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex"
  import moment from "moment"
  const fb = require("../firebaseConfig.js")

  export default {
    data() {
      return {
        showInvitationAttendanceInConfirmation: false,
        showInvitationAttendanceInPlusOneConfirmation: false,
        showInvitationAttendanceOutConfirmation: false,
        width: 0,
        index: 0,
        pages: 0
      }
    },
    computed: {
      ...mapState([ "authUser", "appUser", "selectedEvent" ])
    },
    beforeRouteLeave(to, from, next) {
      if (from.params.event) {
        this.clearInvitationChanges(from.params.event, this.appUser)
      }

      next()
    },
    methods: {
      onScrollDebounce({scrollWidth, width, left}) {
        this.width = width;
        this.index = Math.round(left / width);
        this.pages = Math.round(scrollWidth / width);
      },
      onPageTapped(i, mediaItems) {
        if (i === this.pages - 1) {
          // If last page, always scroll to last item
          this.$refs.horizontal.scrollToIndex(mediaItems.length - 1)
        } else {
          this.$refs.horizontal.scrollToLeft(i * this.width)
        }
      },
      canSetEventAttending(event, appUser) {
        return (this.invitationForAppUser(event, appUser).attendanceStatus != 1 && (!this.isEventClosedFullAttendees(event) || this.invitationForAppUser(event, appUser).attendanceStatus == 2));
      },
      canSetEventAttendingPlusOne(event, appUser) {
        return (this.invitationForAppUser(event, appUser).attendanceStatus != 2 && (!this.isEventClosedForTwoFullAttendees(event) || (this.invitationForAppUser(event, appUser).attendanceStatus == 1 && !this.isEventClosedFullAttendees(event))));
      },
      canSetEventNotAttending(event, appUser) {
        return (this.invitationForAppUser(event, appUser).attendanceStatus != 3);
      },
      attendanceInButtonTapped(event, appUser) {
        if (this.invitationForAppUser(event, appUser).attendanceStatus == 0) {
          this.updateInvitationAttendanceStatus(event, appUser, 1)
        }
        else {
          this.showInvitationAttendanceInConfirmation = true
        }
      },
      attendanceInPlusOneButtonTapped(event, appUser) {
        if (this.invitationForAppUser(event, appUser).attendanceStatus == 0) {
          this.updateInvitationAttendanceStatus(event, appUser, 2)
        }
        else {
          this.showInvitationAttendanceInPlusOneConfirmation = true
        }
      },
      attendanceOutButtonTapped(event, appUser) {
        if (this.invitationForAppUser(event, appUser).attendanceStatus == 0) {
          this.updateInvitationAttendanceStatus(event, appUser, 3)
        }
        else {
          this.showInvitationAttendanceOutConfirmation = true
        }
      },
      showMessages(event) {
        this.$router.push({ name: 'MessageList', params: { event: event } })
      },
      mostRecentMessage(messages) {
        const sortedEventMessages = [...messages].sort((a,b) => a.dateTime < b.dateTime); // [...] is to force a copy and not mutate
        return sortedEventMessages[sortedEventMessages.length - 1]; // we already know there's at least 1
      },
      invitationForAppUser(event, appUser) {
        return this.invitationForPhoneNumber(event, appUser.phoneNumber)
      },
      invitationForPhoneNumber(event, phoneNumber) {
        return event.invitations.find(invitation => invitation.invitee.phoneNumber === phoneNumber)
      },
      invitationAttendanceCount(event, attendanceStatus) {
        let attendanceStatuses = event.invitations.map(invitation => invitation.attendanceStatus)
        return attendanceStatuses.reduce((count, as) => as === attendanceStatus ? count + 1 : count, 0)
      },
      updateInvitation(eventId, invitationChanged) {
        let eventReference = fb.eventsCollection.doc(eventId)

        let transaction = fb.db.runTransaction(t => {
          return t.get(eventReference).then(eventDocument => {
            const freshEvent = eventDocument.data()

            var changedIndex = freshEvent.invitations.findIndex(invitation => invitation.invitee.phoneNumber === invitationChanged.invitee.phoneNumber)
            if (changedIndex != -1) {
              if (invitationChanged.attendanceStatus != freshEvent.invitations[changedIndex].attendanceStatus) {
                // Clear this invitation's changes (since an attendance status change requires explicit interaction)
                invitationChanged.changes = []

                // Set the change statuses of all OTHER invitations to .inviteesAttendanceChanged to indicate that this attendance change happened
                freshEvent.invitations.forEach(invitation => {
                  if (invitation.invitee.phoneNumber != invitationChanged.invitee.phoneNumber) {
                    this.setChangeStatusForUserInvitation(invitation, this.$InvitationChangeStatus.inviteesAttendanceChanged)
                  }
                })
              }

              freshEvent.invitations.splice(changedIndex, 1, invitationChanged)
            }

            var changedPhoneNumberIndex = freshEvent.invitationPhoneNumbers.findIndex(invitationPhoneNumber => invitationPhoneNumber === invitationChanged.invitee.phoneNumber)
            if (changedIndex != -1) {
              freshEvent.invitationPhoneNumbers.splice(changedPhoneNumberIndex, 1, invitationChanged.invitee.phoneNumber)
            }

            t.update(eventReference, { invitations: freshEvent.invitations });
          });
        }).then(result => {
          console.log("updateInvitation success!")
        }).catch(error => {
          console.log(`updateInvitation error: ${error}`)
        });
      },
      updateInvitationAttendanceStatus(event, appUser, attendanceStatus) {
        const invitation = this.invitationForAppUser(event, appUser)
        if (attendanceStatus != invitation.attendanceStatus) {
          invitation.attendanceStatus = attendanceStatus
          this.updateInvitation(event.id, invitation)
        }
      },
      isChangeStatusSetForUserInvitation(invitation, changeStatus) {
        return (invitation.changes && invitation.changes.map(change => change.changeStatus).includes(changeStatus))
      },
      setChangeStatusForUserInvitation(invitation, changeStatus) {
        if (!invitation.changes) {
          invitation.changes = []
        }
        let change = { 'createdDateTime': Date(), 'changeStatus': changeStatus };
        invitation.changes.push(change)
      },
      clearInvitationChanges(event, appUser) {
        const invitation = this.invitationForAppUser(event, appUser)
        var invitationChanged = false

        // If the user had not viewed this invitation (attendance status == .unknown), change their status to .undecided
        if (invitation.attendanceStatus == 0) {
          invitation.attendanceStatus = 4
          invitationChanged = true
        }

        // If there is any change status, clear it
        if (invitation.changes && invitation.changes.length > 0) {
          invitation.changes = []
          invitationChanged = true
        }

        if (invitationChanged) {
          this.updateInvitation(event.id, invitation)
        }
      }
    },
    filters: {
      formatDate(val) {
        if (!val) {
          return "-"
        }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          return val
        }
        return `${val.substring(0, 200)}...`
      }
    }
    // Probably not in mounted() but this is how you read a query paramater within a component, which might eventually help in supporting deep linking
    // mounted() {
    //   console.log(`EVENTID: ${this.$route.query.eventId}`)
    // }
  }
</script>

<style scoped>
/* Hide prev/next nav buttons for horizontal control */
.horizontal >>> .v-hl-btn-prev svg {
  display: none;
}

.horizontal >>> .v-hl-btn-next svg {
  display: none;
}
button > img,
button > span {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Event.vue